import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { IconName } from '@thiememeulenhoff/types';
import { tag, alertStyles } from './alert.styles';
import { AlertType, alertIcons, AlertVariant } from './alert.types';

@customElement(tag)
export class AlertComponent extends TmElement {
  @property({ type: String, reflect: true })
  type: AlertType = 'info';

  @property({ reflect: true })
  variant: AlertVariant = 'default';

  @property({ type: Boolean, reflect: true })
  dismissable?: boolean;

  @property({ type: String, reflect: true })
  icon?: IconName;

  static override styles = alertStyles;

  override render() {
    return html`
      ${this.#iconTemplate()}
      <span><slot></slot></span>
      ${this.#dismissableTemplate()}
    `;
  }

  #iconTemplate() {
    return html`<a-icon
      class="alert-icon-${this.type}"
      name="${this.icon ?? alertIcons[this.type]}"
    ></a-icon>`;
  }

  #dismissableTemplate() {
    if (this.dismissable) {
      return html`<a-icon-button
        icon="close"
        class="close"
        color="grey"
        icon-size="small"
        @click=${this.#dismiss}
        data-test="alert-close"
      ></a-icon-button>`;
    }
    return html``;
  }

  #dismiss(event: Event) {
    event.stopPropagation();
    this.remove();
    this.dispatchLocalEvent({ eventName: 'dismiss' });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-alert': AlertComponent;
  }
}
